// The subject line is how a broker tells one of their listings from another,
// and how the reply matcher tells one campaign thread from another. Two rows at
// the same street address differ only by the suite/unit the upload carries in
// 'Property Name' / 'Suite' (see uploadedPropertyRows), so the subject has to
// carry it too: without it the second row reads as a duplicate of the first and
// never sends.

function normalizeSubjectSegment(value) {
  return String(value ?? '').replace(/\s+/gu, ' ').trim();
}

function comparableSubjectSegment(value) {
  return normalizeSubjectSegment(value).toLocaleLowerCase();
}

/**
 * Build the campaign subject for one property row.
 *
 * "<address>[, <suite / property name>][, <city>]", with the suite included
 * only when the upload supplied one that the address does not already carry.
 * Returns null when the row has no address, so callers keep whatever fallback
 * they already use for an address-less row.
 */
export function buildCampaignPropertySubject(property) {
  const address = normalizeSubjectSegment(property?.address);
  if (!address) return null;

  const propertyName = normalizeSubjectSegment(property?.propertyName);
  const city = normalizeSubjectSegment(property?.city);
  const comparableAddress = comparableSubjectSegment(address);
  const comparablePropertyName = comparableSubjectSegment(propertyName);
  const includePropertyName = Boolean(comparablePropertyName)
    && !comparableAddress.includes(comparablePropertyName);

  return [address, includePropertyName ? propertyName : '', city]
    .filter(Boolean)
    .join(', ');
}
